import type { CandidateJobsQueryParams } from '@/modules/candidates/types';

export const candidateFeedbackQueryKeys = {
  detail: (jobId: string, candidateId: string) =>
    ['candidate-feedback', jobId, candidateId] as const,
};

export const candidateJobQueryKeys = {
  all: ['candidate-jobs'] as const,
  lists: (jobId: string | undefined) =>
    [...candidateJobQueryKeys.all, 'list', jobId] as const,
  list: (jobId: string | undefined, filters: CandidateJobsQueryParams = {}) =>
    [...candidateJobQueryKeys.lists(jobId), filters] as const,
  infiniteList: (
    jobId: string | undefined,
    filters: CandidateJobsQueryParams = {},
  ) => [...candidateJobQueryKeys.lists(jobId), 'infinite', filters] as const,
  // Under the job's lists, so whatever refreshes the list refreshes its counts.
  counts: (jobId: string | undefined) =>
    [...candidateJobQueryKeys.lists(jobId), 'counts'] as const,
  detail: (jobId: string, candidateId: string) =>
    [...candidateJobQueryKeys.list(jobId), 'candidate', candidateId] as const,
};

export const candidateAssessmentQueryKeys = {
  all: ['candidate-assessments'] as const,
  jobs: (jobId: string) =>
    [...candidateAssessmentQueryKeys.all, 'job', jobId] as const,
  detail: (jobId: string, candidateId: string) =>
    [
      ...candidateAssessmentQueryKeys.jobs(jobId),
      'candidate',
      candidateId,
    ] as const,
};

export const candidateRejectionMessageQueryKeys = {
  all: ['candidate-rejection-messages'] as const,
  list: (jobId: string, candidateIds: string[]) =>
    [...candidateRejectionMessageQueryKeys.all, jobId, candidateIds] as const,
};

export const candidateApprovalMessageQueryKeys = {
  all: ['candidate-approval-message'] as const,
  detail: (jobId: string, candidateId: string) =>
    [...candidateApprovalMessageQueryKeys.all, jobId, candidateId] as const,
};

export const candidateJobNoteQueryKeys = {
  all: ['candidate-job-notes'] as const,
  list: (candidateJobId: string | null) =>
    [...candidateJobNoteQueryKeys.all, candidateJobId] as const,
};
